import { VisuallyHidden } from "@99tech/ui";
import { Box, Stack, Typography } from "@mui/material";
import React, { useCallback, useContext } from "react";
import { Apps, Bg, BtnLogin, BtnRegister, Chars, Games, Logo, Providers } from "src/assets";
import { FloatingBanner } from "src/main/components";
import { AppContext } from "src/main/constants";
import { createStyles, isMobile } from "src/main/utils";

interface LandingPageProps extends React.PropsWithChildren {}

const LandingPage: React.FC<LandingPageProps> = (props) => {
  const { urls } = useContext(AppContext);
  const { loginUrl, registerUrl } = urls ?? {};

  const handleClick = useCallback(
    (type: "login" | "register") => (e: React.MouseEvent<HTMLAnchorElement>) => {
      e.preventDefault();
      if (type === "login") {
        window.open(loginUrl, "_blank", isMobile() ? "width=full,height=full" : "");
      } else {
        window.open(registerUrl, "_blank", isMobile() ? "width=full,height=full" : "");
      }
    },
    [loginUrl, registerUrl],
  );

  return (
    <Box sx={styles.root}>
      <VisuallyHidden as="h1">MAINWOW</VisuallyHidden>
      <Stack
        direction="column"
        alignItems="center"
        width="100%"
        textAlign="center"
      >
        <Typography
          className="text-gradient"
          fontSize={26}
          fontWeight={900}
        >
          Situs slot sistem baru
        </Typography>
        <Typography
          fontSize={12}
          lineHeight={1.22}
          fontWeight={900}
          mt={0.2}
        >
          Standar internasional, Persetujuan penarikan cepat Membayar untuk setiap taruhan!
        </Typography>
        <img
          alt="logo"
          src={Logo}
          style={{ width: 280, marginTop: "-30px" }}
        />

        <Stack
          direction="row"
          justifyContent="center"
          gap={2.5}
          mt={-2.8}
          zIndex={10}
        >
          <a
            href={loginUrl}
            onClick={handleClick("login")}
            target="_blank"
            rel="noreferrer"
          >
            <img
              alt="btn-login"
              src={BtnLogin}
              style={{ height: 43, marginRight: -6 }}
            />
          </a>
          <a
            href={registerUrl}
            onClick={handleClick("register")}
            target="_blank"
            rel="noreferrer"
          >
            <img
              alt="btn-register"
              src={BtnRegister}
              style={{ height: 43, marginLeft: -6 }}
            />
          </a>
        </Stack>

        <img
          alt="chars"
          src={Chars}
          style={{ width: 360, marginTop: "-4px" }}
        />

        <Stack
          mt={-2.5}
          alignItems="center"
          justifyContent="center"
          gap={1}
        >
          <Typography
            fontSize={7}
            fontWeight={500}
            lineHeight={1.2}
            color="#fff"
            px={2}
          >
            Mainwow adalah situs slot web langsung dengan standar internasional yang siap membawa Anda menemukan saluran
            penghasilan tanpa harus menginvestasikan banyak uang. Di Mainwow, Anda tidak perlu lelah atau menghadapi
            kekecewaan. Mainwow siap menyediakan banyak permainan slot dari penyedia game terkemuka. Mainwow memberikan
            kesenangan sepenuhnya dengan permainan yang paling mudah dimainkan. Mainwow bisa dimainkan di mana saja dan
            kapan saja untuk hiburan dan relaksasi, dan tentunya dapat memenangkan hadiah. Mainwow menjamin pembayaran
            penuh. Mainwow memberikan promosi tanpa batas, situs slot langsung 100%. Mainwow mudah digunakan, aman, dan
            mendukung semua perangkat. Mainwow adalah situs slot yang bisa dimainkan kapan saja, di mana saja, baik di
            ponsel maupun komputer. Mainwow adalah situs slot langsung yang benar-benar membayar, menggunakan sistem
            slot dari penyedia asli dan terbaru. Mainwow tidak mengunci akun, bisa dimainkan setiap hari! Mainwow
          </Typography>
          <img
            alt="games"
            src={Games}
            style={{ width: 360, marginTop: "-10px", marginBottom: "-30px" }}
          />
          <Typography
            fontSize={7}
            fontWeight={500}
            lineHeight={1.2}
            color="#fff"
            textAlign="center"
            px={2}
          >
            Bermain slot online di Mainwow tidak sesulit yang Anda bayangkan! Anda dapat memulai dengan mudah di Mainwow
            dengan memilih dari ratusan permainan slot favorit Anda di situs Mainwow kami, dan mempelajari teknik khusus
            dari Mainwow yang dapat meningkatkan peluang Anda untuk memenangkan hadiah besar di Mainwow. Kami memiliki
            banyak penyedia game terkemuka yang dapat Anda pilih, seperti...
          </Typography>

          <img
            alt="providers"
            src={Providers}
            style={{ width: 240, marginTop: "-8px", marginBottom: "-4px" }}
          />
          <Typography
            fontSize={8}
            fontWeight={900}
            lineHeight={1.2}
            color="#ffff00"
            textAlign="center"
            px={2}
          >
            Mendukung semua perangkat
          </Typography>
          <img
            alt="apps"
            src={Apps}
            style={{ width: 150, marginTop: "-4px" }}
          />
        </Stack>
      </Stack>

      <FloatingBanner />
    </Box>
  );
};

const styles = createStyles({
  root: {
    backgroundImage: `url(${Bg})`,
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    backgroundPosition: "top",
    backgroundColor: "#03103E",

    p: "16px",
    mx: "-16px",

    flexGrow: 1,
    display: "flex",
    flexDirection: "column",
    gap: "0px",
    position: "relative",
    alignItems: "center",
    justifyContent: "center",
    overflowX: "hidden",
    color: "#fff",
  },
});

export default LandingPage;
